export default function FilterTag({ name, value, onRemove, children }) {
  return (
    <div className='filterTag inlineFlex alignCenter'>
      <span className='text'>{children}</span>
      <button className='flatBtn' aria-label='remove filter' onClick={() => onRemove(name, value)}>
        <svg width='24.818' height='24.818' viewBox='0 0 24.818 24.818' fill='#fff'>
          <path
            d='M16.713,9.453H9.453v7.26H7.26V9.453H0V7.26H7.26V0H9.453V7.26h7.26Zm0,8.931'
            transform='translate(13) rotate(45)'
          />
        </svg>
      </button>

      <style jsx>{`
        .filterTag {
          min-width: 11.6rem;
          height: 4.2rem;
          padding: 0 1.1rem 0 1.5rem;
          border-radius: 2.1rem;
          color: #fff;
          background: var(--secondary-button-bg);
          font-size: 1.6rem;

          .text {
            margin: 0 1rem 0 0;
          }

          button {
            width: 2.7rem;
            height: 2.2rem;
            margin: 0 0 0 auto;
            outline: none;

            svg {
              width: 100%;
              height: 100%;
            }

            &:focus svg {
              fill: var(--primary-color);
            }
          }
        }
      `}</style>
    </div>
  )
}
